const vars = {}
export default vars